<template>
  <section class="network-stats-section home-section" aria-labelledby="network-stats-title">
    <div class="container network-stats-layout">
      <div class="network-stats-heading">
        <p class="eyebrow">{{ $t("All Cyprus, one network") }}</p>
        <h2 id="network-stats-title">{{ $t("premium.networkTitle") }}</h2>
        <p>{{ $t("premium.networkDetail") }}</p>
      </div>
      <div class="network-stats-grid">
        <article class="network-stat">
          <span class="network-stat-icon" aria-hidden="true"><i class="fa fa-calendar-check"></i></span>
          <div class="network-stat-value" aria-live="polite" :aria-busy="loading">
            <span v-if="loading" class="network-stat-placeholder">{{ $t("networkStats.loading") }}</span>
            <strong v-else-if="openRequests !== null">{{ formatCount(openRequests) }}</strong>
            <span v-else class="network-stat-placeholder">{{ $t("premium.shiftsUnavailable") }}</span>
          </div>
          <h3>{{ $t("Available Shifts") }}</h3>
          <p>{{ $t("Current shifts available for nurses to claim.") }}</p>
          <router-link class="text-link" to="/login?type=employee">{{ $t("premium.findShifts") }} <i class="fa fa-arrow-right" aria-hidden="true"></i></router-link>
          <button v-if="!loading && openRequests === null" type="button" class="btn btn-outline-primary btn-sm mt-3" @click="fetchCounts">{{ $t("premium.retry") }}</button>
        </article>
        <article class="network-stat network-stat--nurses">
          <span class="network-stat-icon" aria-hidden="true"><i class="fa fa-user-nurse"></i></span>
          <div class="network-stat-value" aria-live="polite" :aria-busy="loading">
            <span v-if="loading" class="network-stat-placeholder">{{ $t("networkStats.loadingNurses") }}</span>
            <strong v-else-if="registeredNurses !== null">{{ formatCount(registeredNurses) }}</strong>
            <span v-else class="network-stat-placeholder">{{ $t("networkStats.nursesUnavailable") }}</span>
          </div>
          <h3>{{ $t("Registered Nurses") }}</h3>
          <p>{{ $t("networkStats.nursesDescription") }}</p>
          <router-link class="text-link" to="/organisations">{{ $t("premium.forOrganisations") }} <i class="fa fa-arrow-right" aria-hidden="true"></i></router-link>
          <button v-if="!loading && registeredNurses === null" type="button" class="btn btn-outline-primary btn-sm mt-3" @click="fetchCounts">{{ $t("premium.retry") }}</button>
        </article>
        <article class="network-stat">
          <span class="network-stat-icon" aria-hidden="true"><i class="fa fa-house-medical"></i></span>
          <div class="network-stat-value" aria-live="polite" :aria-busy="loading">
            <span v-if="loading" class="network-stat-placeholder">{{ $t("networkStats.loadingOrganisations") }}</span>
            <strong v-else-if="registeredOrganisations !== null">{{ formatCount(registeredOrganisations) }}</strong>
            <span v-else class="network-stat-placeholder">{{ $t("networkStats.organisationsUnavailable") }}</span>
          </div>
          <h3>{{ $t("networkStats.organisationsTitle") }}</h3>
          <p>{{ $t("networkStats.organisationsDescription") }}</p>
          <router-link class="text-link" to="/organisations">{{ $t("premium.forOrganisations") }} <i class="fa fa-arrow-right" aria-hidden="true"></i></router-link>
          <button v-if="!loading && registeredOrganisations === null" type="button" class="btn btn-outline-primary btn-sm mt-3" @click="fetchCounts">{{ $t("premium.retry") }}</button>
        </article>
      </div>
    </div>
  </section>
</template>
<script>
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
export default {
  name: "StatsComponent",
  data() {
    return {openRequests: null, registeredNurses: null, registeredOrganisations: null, loading: true}
  },
  mounted() { this.fetchCounts() },
  methods: {
    formatCount(value) {
      return new Intl.NumberFormat(["gr", "el"].includes(this.$i18n.locale) ? "el-GR" : this.$i18n.locale).format(value)
    },
    async fetchCounts() {
      this.loading = true
      try {
        const response = await FirebaseFunctionsHelper.callFunction("request-getEntityCounts", {})
        const count = response?.[0]?.requests
        this.openRequests = Number.isSafeInteger(count) && count >= 0 ? count : null
        const employees = response?.[0]?.employees
        this.registeredNurses = Number.isSafeInteger(employees) && employees >= 0 ? employees : null
        const organisations = response?.[0]?.organizations
        this.registeredOrganisations = Number.isSafeInteger(organisations) && organisations >= 0 ? organisations : null
      } catch (error) {
        this.openRequests = null
        this.registeredNurses = null
        this.registeredOrganisations = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.network-stats-section { background: #f4f8fa; }
.network-stats-layout { display: grid; grid-template-columns: 1fr; align-items: center; gap: 48px; text-align: start; }
.network-stats-heading > p:last-child { max-width: 650px; margin: 22px 0 0; color: var(--care-muted); line-height: 1.8; }
.network-stats-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; }
.network-stat { padding: 30px; border: 1px solid var(--care-line); border-radius: var(--care-card-radius); background: #fff; }
.network-stat--nurses { background: #e3edf3; border-color: #ccdee8; }
.network-stat-icon { display: grid; place-items: center; width: 46px; height: 46px; border-radius: 12px; background: #edf5f8; color: var(--care-primary); font-size: 21px; }
.network-stat--nurses .network-stat-icon { background: #fff; }
.network-stat-value { min-height: 82px; display: flex; align-items: center; margin-top: 18px; }
.network-stat-value strong { color: var(--care-primary); font-size: clamp(42px, 5vw, 60px); font-weight: 600; line-height: 1.15; letter-spacing: -.04em; font-variant-numeric: tabular-nums; }
.network-stat-placeholder { color: var(--care-muted); font-size: 14px; line-height: 1.6; }
.network-stat h3 { font-size: 19px; font-weight: 700; margin: 10px 0; }
.network-stat p { color: var(--care-muted); font-size: 14px; line-height: 1.8; margin-bottom: 24px; }
.network-stat .text-link { font-size: 13px; }
@media (max-width: 991px) { .network-stats-layout { grid-template-columns: 1fr; gap: 30px; } .network-stats-heading > p:last-child { max-width: 650px; } }
@media (max-width: 767px) { .network-stats-grid { grid-template-columns: 1fr; gap: 16px; } .network-stat { padding: 24px; } }
</style>
